import { Box, Typography } from '@mui/material'
import React from 'react'

import { HdpNavigationTab } from '@f-fertighaus/applications/Next/components/common/navigation/tabs/useActiveTabs'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { isNotEmptyArray } from '@f-fertighaus/applications/Next/utils/typeguards/isNotEmptyArray'
import { AreaInformation } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/FloorPlansSection/AreaInformation'
import { FloorPlanGalleryOverview } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/FloorPlansSection/FloorPlanGalleryOverview'
import { RequestFreeInfoCTA } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/FloorPlansSection/RequestFreeInfoCTA'
import { SectionDescription } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseSections/sections/FloorPlansSection/SectionDescription'

export const FloorPlansSection = () => {
  const {
    state: {
      outside_measurements_length,
      outside_measurements_width,
      floor_plans,
      name
    }
  } = useHouseDetail()

  if (!isNotEmptyArray(floor_plans)) {
    return null
  }

  return (
    <Box>
      <Typography
        component='h2'
        id={`navigation-category-${HdpNavigationTab.floorPlans}`}>
        <Typography variant='mediumTitle' component='span' display='block'>
          {t('houseDetailPage.floor_plans.title')}
        </Typography>
        <Typography component='span' variant='body2' display='block'>
          {t('houseDetailPage.heading_suffix', { houseName: name })}
        </Typography>
      </Typography>
      {(outside_measurements_length || outside_measurements_width) && (
        <AreaInformation />
      )}
      <FloorPlanGalleryOverview />
      <SectionDescription />
      <RequestFreeInfoCTA />
    </Box>
  )
}
